import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import isEmpty from "../validations/is-empty";

// Extend dayjs with timezone support
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

const getDateAndTime = (date) => {
  const timezone = isEmpty(localStorage.getItem("timezoneMode"))
    ? "Europe/London"
    : localStorage.getItem("timezoneMode");

  const d = dayjs(date).tz(timezone);
  const year = d.year();
  const month = String(d.month() + 1).padStart(2, "0"); // Months are 0-based, so add 1
  const day = String(d.date()).padStart(2, "0");
  const hours = String(d.hour()).padStart(2, "0");
  const minutes = String(d.minute()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export default getDateAndTime;
